export default {
  install(Vue, options) {
    Object.defineProperty(Vue.config.globalProperties, '$profile', {
      get() {
        return this.$store.getters['profiles/currentProfile']
      }
    })
  }
}
